import React from 'react';
import PropTypes from 'prop-types';

// Icon
const RegisterIcon = ({ className, width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 240 240"
  >
    <g>
      <path
        className="icon"
        fill={fill}
        d="M213.26,92.188c-2.014-1.933-4.144-3.419-6.33-4.417c-2.191-1-4.515-1.508-6.906-1.508c-5.313,0-10.146,2.137-14.399,6.386	c-1.372,1.3-24.727,24.656-73.5,73.501c-0.46,0.461-0.812,1.007-1.043,1.618l-0.001,0.005c-0.382,1.649-5.325,18.017-9.588,32.09	l-0.165,0.54c-0.369,1.423-0.07,2.63,0.917,3.689l0.102,0.11l0.084,0.125c0.051,0.076,0.118,0.142,0.197,0.195l0.162,0.036	l0.339,0.257c0.118,0.071,0.413,0.233,0.413,0.233c0.159,0.073,0.316,0.128,0.458,0.164c0.143,0.033,0.288,0.071,0.466,0.117	c0.153,0.04,0.31,0.061,0.466,0.061c0.422,0,0.789-0.067,1.09-0.2l0.085-0.038l0.09-0.028c16.114-5.276,26.832-8.696,31.936-10.186	c0.303-0.074,0.6-0.189,0.872-0.35c0.266-0.146,0.524-0.34,0.761-0.571c8.82-8.753,22.874-22.668,42.146-41.746	c20.102-19.901,29.877-29.621,31.699-31.522c4.545-4.701,6.811-9.626,6.734-14.633C220.257,101.258,217.876,96.574,213.26,92.188z	 M122.752,192.04c-5.848,1.933-10.046,3.335-12.601,4.184c0.701-2.322,1.974-6.368,3.835-12.132	c1.86-5.778,3.057-9.625,3.596-11.562c3.792,1.006,7.351,3.172,10.684,6.501c2.63,2.636,4.492,5.728,5.574,9.29	C132.29,188.867,128.597,190.102,122.752,192.04z M139.99,183.099c-1.546-3.566-3.674-6.738-6.385-9.522	c-3.248-3.258-6.889-5.696-10.911-7.315c2.709-2.707,8.57-8.591,17.589-17.647c9.017-9.057,17.57-17.607,25.663-25.663	c8.085-8.044,14.258-14.197,18.519-18.458c3.871,0.931,7.508,3.097,10.908,6.507c1.396,1.386,2.57,2.975,3.548,4.756	c0.96,1.781,1.577,3.111,1.856,4.007c0.263,0.881,0.476,1.721,0.638,2.489C190.961,132.629,170.485,152.908,139.99,183.099z	 M211.635,110.757c-0.773,1.553-1.942,3.101-3.48,4.655c0,0.071-0.04,0.152-0.117,0.227c-0.075,0.076-0.156,0.157-0.232,0.237	c-0.076,0.077-0.191,0.188-0.339,0.345c-1.559-4.027-3.8-7.548-6.74-10.569c-3.096-3.091-6.541-5.459-10.331-7.083	c0.071-0.076,0.188-0.187,0.346-0.349l0.231-0.232c0.384-0.385,0.87-0.81,1.446-1.275c0.588-0.466,1.625-1.047,3.132-1.741	c1.514-0.703,3-1.052,4.474-1.052c1.392,0,2.768,0.309,4.123,0.931c1.356,0.622,2.652,1.548,3.886,2.788 c1.549,1.472,2.732,2.939,3.542,4.417c0.813,1.467,1.221,2.898,1.221,4.291C212.795,107.741,212.399,109.208,211.635,110.757z"
      />
      <polygon
        className="icon"
        fill={fill}
        points="203,145 203,223 37,223 37,17 203,17 203,76 212,79 212,6 26,6 26,236 212,236 212,137 "
      />
      <rect className="icon" fill={fill} x="54" y="82" width="83" height="11" />
      <rect className="icon" fill={fill} x="54" y="154" width="32" height="11" />
      <rect className="icon" fill={fill} x="54" y="119" width="58" height="12" />
      <rect className="icon" fill={fill} x="54" y="43" width="109" height="11" />
    </g>
  </svg>
);

RegisterIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

RegisterIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
};

export default RegisterIcon;
